import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { capitalize } from '@attain-apps/string-utils'

import * as state from '../../../../../../state'
import * as errorMessage from '../../error-message'

/**
 * Modal used for creating and editing Admin Center zones.
 */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.text.Component,
    ds.overlay.centered.Component,
    ds.layout.widget.Component,
    errorMessage.Component,
  ],
  selector: 'atn-admin-zone-modal',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.zones.Collection} */
  public readonly zonesEc = ngCore.inject(state.admin.zones.Collection)

  /** Editing zone */
  public readonly zoneSg = ngCore.computed(() =>
    this.zonesEc.plugins.currentEntityPlugin.feature.selectors
      .getEditedEntity()
      .asSignal(),
  )

  /** Editing zone name*/
  public readonly nameSg = ngCore.computed((zone = this.zoneSg()) => zone?.name)

  /** Editing zone alias*/
  public readonly aliasSg = ngCore.computed(
    (zone = this.zoneSg()) => zone?.alias,
  )

  /** Editing zone code*/
  public readonly codeSg = ngCore.computed((zone = this.zoneSg()) => zone?.code)

  /** Editing zone description*/
  public readonly descriptionSg = ngCore.computed(
    (zone = this.zoneSg()) => zone?.description,
  )

  /**
   * Shows dialog title based on {@link isNew}
   */
  public readonly titleSg = ngCore.computed(
    (
      isNew = this.zonesEc.plugins.currentEntityPlugin.feature.selectors
        .isCreating()
        .asSignal(),
    ) => `${isNew ? 'Create' : 'Update'} Zone`,
  )

  /**
   * Updates a specific property of the currently edited zone.
   */
  public updateZonePropertyHandler<K extends keyof ents.core.admin.Zone.Input>(
    prop: K,
    value: ents.core.admin.Zone.Input[K],
  ): void {
    this.zonesEc.plugins.editingPlugin.feature.actions.edit
      .from(`Dialog.${capitalize(prop)}.Inputted`)
      .dispatch({
        edit: zone => {
          if (!zone) {
            return
          }
          zone[prop] = value
        },
      })
  }

  /** Submit changes handler */
  public saveClickHandler(): void {
    this.zonesEc.plugins.editingPlugin.feature.actions.submit
      .from('Dialog.SaveButton.Clicked')
      .dispatch({
        current: true,
        skipUnset: true,
      })
  }

  /** Discard changes handler */
  public cancelClickHandler(): void {
    this.zonesEc.plugins.editingPlugin.feature.actions.discard
      .from('Dialog.CancelButton.Clicked')
      .dispatch({
        current: true,
        skipUnset: true,
      })
  }
}
